import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { recipeScheduleAPI } from '../../utils/api';
import RecipeDetailModal from '../recipes/RecipeDetailModal';
import './ScheduledRecipeCard.css';

const ScheduledRecipeCard = ({ schedule, onRemoved, user, onScheduleSuccess }) => {
  const [isRemoving, setIsRemoving] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showRecipeModal, setShowRecipeModal] = useState(false);

  const recipe = schedule.recipes;

  const handleRemoveClick = (e) => {
    e.stopPropagation();
    setShowConfirm(true);
  };

  const handleConfirmRemove = async (e) => {
    e.stopPropagation();
    
    try {
      setIsRemoving(true);
      await recipeScheduleAPI.unscheduleRecipe(schedule.id);
      onRemoved();
    } catch (error) {
      console.error('Error removing scheduled recipe:', error);
      // Could add error handling UI here
    } finally {
      setIsRemoving(false);
      setShowConfirm(false);
    }
  };

  const handleCancelRemove = (e) => {
    e.stopPropagation();
    setShowConfirm(false);
  };

  const handleCardClick = () => {
    // Open recipe details modal when clicking on scheduled recipe
    setShowRecipeModal(true);
  };

  const getMealTypeIcon = (mealType) => {
    switch (mealType) {
      case 'breakfast': return '🌅';
      case 'lunch': return '☀️';
      case 'dinner': return '🌙';
      case 'snack': return '🍎';
      default: return '🍽️';
    }
  };

  return (
    <>
    <div className="scheduled-recipe-card" onClick={handleCardClick}>
      <div className="recipe-info">
        <div className="recipe-header">
          <div className="meal-type">
            <span className="meal-icon">{getMealTypeIcon(schedule.meal_type)}</span>
            <span className="meal-label">{schedule.meal_type}</span>
          </div>
          {!showConfirm && (
            <button 
              className="remove-button"
              onClick={handleRemoveClick}
              disabled={isRemoving}
              aria-label="Remove recipe from schedule"
            >
              ×
            </button>
          )}
        </div>
        
        <div className="recipe-details">
          <h4 className="recipe-title">{recipe.title}</h4>
        </div>
      </div>

      {showConfirm && (
        <div className="confirm-remove" onClick={(e) => e.stopPropagation()}>
          <p>Remove this recipe?</p>
          <div className="confirm-buttons">
            <button 
              className="confirm-yes"
              onClick={handleConfirmRemove}
              disabled={isRemoving}
            >
              {isRemoving ? 'Removing...' : 'Yes'}
            </button>
            <button 
              className="confirm-no"
              onClick={handleCancelRemove}
              disabled={isRemoving}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
    
    {showRecipeModal && createPortal(
      <RecipeDetailModal
        recipe={recipe}
        isOpen={showRecipeModal}
        onClose={() => setShowRecipeModal(false)}
        onRecipeUpdated={onRemoved} // Refresh calendar if recipe is updated
        user={user}
        onScheduleSuccess={onScheduleSuccess}
      />,
      document.body
    )}
    </>
  );
};

export default ScheduledRecipeCard;